import React from 'react';

interface CardBottomSvgProps {
  width?: number;
  height?: number;
}

const CardBottomSvg: React.FC<CardBottomSvgProps> = ({ width = 380, height = 75 }) => {
  // 计算底部圆角的位置
  const bottomY = height - 0.5;
  const cornerStartY = height - 20.5;
  const cornerControlY = height - 9.5;
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox={`0 0 380 ${height}`}
      fill="none"
      style={{ 
        display: 'block', 
        width: '100%', 
        height: '100%', 
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0
      }}
      preserveAspectRatio="none"
    >
      <path 
        d={`M0 0.5H380V${cornerStartY}C380 ${cornerControlY} 371.046 ${bottomY} 360 ${bottomY}H20C8.9543 ${bottomY} 0 ${cornerControlY} 0 ${cornerStartY}V0.5Z`}
        fill="white"
      />
    </svg>
  );
};

export default CardBottomSvg;